export interface JiraFilters {
	issueFilter: {
		assigneeARIs: string[];
		projectARIs: string[];
	};
}

export type SearchPageJiraHydrationQueryVariables = {
	cloudId: string;
	issueKeys: string[];
};

export const jiraFieldsQueryGenerator = () => {
	return `
	query SearchPageJiraFieldHydration (
		$issueKeys: [String!]!
		$cloudId: ID!
	) {
		jira {
			issuesByKey(cloudId: $cloudId, keys: $issueKeys) {
			  statusField {
				status {
				  name
				}
			  }
			  id
			}
		  }

	}
	`;
};
